module.exports = __webpack_public_path__ + "static/media/cerdo-iberico.cc5bd55c.jpg";